import React from 'react';

import {IMG_DIR} from '#Client/components/constants';
import {NEWS_INDEX} from '#Client/components/Header/Header';
import {Modal} from '#Client/components/Modal/Modal';
import {swatch} from '#Client/components/SettingsModal/SettingsModal.css';
import {
  difficultyTable,
  difficultyTableBodyCell,
  difficultyTableHeaderCell,
  difficultyTableRow,
  swatch0,
  swatch1,
  swatch2,
  swatch3,
  swatch4,
  swatch5,
  swatchContainer,
  whatIsNewImage,
  whatIsNewList,
  whatIsNewListItem,
} from '#Client/components/WhatIsNewModal/WhatIsNewModal.css';
import {useSavedData} from '#Client/context/SavedData';

type WhatIsNewModalProps = {
  onClose: () => void;
};

export const WhatIsNewModal = ({onClose}: WhatIsNewModalProps) => {
  const {updateViewedNewsIndex} = useSavedData();
  updateViewedNewsIndex(NEWS_INDEX);
  return (
    <Modal
      image={`${IMG_DIR}icon_message.png`}
      title="What's New?"
      onClose={onClose}
    >
      <ul className={whatIsNewList}>
        <li className={whatIsNewListItem}>
          <div className={swatchContainer}>
            <div className={`${swatch} ${swatch0} bg_solid_red`}></div>
            <div className={`${swatch} ${swatch1} bg_solid_orange`}></div>
            <div className={`${swatch} ${swatch2} bg_solid_yellow`}></div>
            <div className={`${swatch} ${swatch3} bg_letters_green`}></div>
            <div className={`${swatch} ${swatch4} bg_letters_dark_blue`}></div>
            <div className={`${swatch} ${swatch5} bg_letters_light_blue`}></div>
          </div>
          <div>
            <h3>Fun Background Colors</h3>
            <p>Change the background to a fun new color!</p>
            <p>Choose a solid color or a letter pattern.</p>
            <p>Head over to the Settings to check it out!</p>
            <i>March 23, 2023</i>
          </div>
        </li>
        <li className={whatIsNewListItem}>
          <img
            className={whatIsNewImage}
            height="64"
            src={`${IMG_DIR}icon_hand.png`}
            width="64"
          />
          <div>
            <h3>New Difficulty Settings</h3>
            <p>
              Based on your feedback, I&apos;ve changed the number of hints that
              are given.
              <table className={difficultyTable}>
                <thead>
                  <tr className={difficultyTableRow}>
                    <td className={difficultyTableHeaderCell}>Difficulty</td>
                    <td className={difficultyTableHeaderCell}>
                      Number of hints
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr className={difficultyTableRow}>
                    <td className={difficultyTableBodyCell}>Easy</td>
                    <td className={difficultyTableBodyCell}>9</td>
                  </tr>
                  <tr className={difficultyTableRow}>
                    <td className={difficultyTableBodyCell}>Medium</td>
                    <td className={difficultyTableBodyCell}>7</td>
                  </tr>
                  <tr className={difficultyTableRow}>
                    <td className={difficultyTableBodyCell}>Hard</td>
                    <td className={difficultyTableBodyCell}>5</td>
                  </tr>
                  <tr className={difficultyTableRow}>
                    <td className={difficultyTableBodyCell}>Brutal</td>
                    <td className={difficultyTableBodyCell}>3</td>
                  </tr>
                </tbody>
              </table>
            </p>
            <p>
              Also, there was a bug in the &quot;Settings&quot; menu
              &quot;Difficulty&quot; dropdown that is now fixed.
            </p>
            <i>March 18, 2023</i>
          </div>
        </li>
        <li className={whatIsNewListItem}>
          <img
            className={whatIsNewImage}
            height="64"
            src={`${IMG_DIR}icon_rankings.png`}
            width="64"
          />
          <div>
            <h3>New feature: Leaderboards!</h3>
            <p>
              From the gear icon in the top right, click the Leaderboards option
              to see where you stack up against other players!
            </p>
            <p>
              <b>Optional: </b>Enter your name in &apos;Settings&apos; for
              display on the Leaderboard
            </p>
            <i>February 6, 2022</i>
          </div>
        </li>
      </ul>
    </Modal>
  );
};
